import type { Config } from '@kanbu/config';

export type ConfigType = {
  debug: boolean;
};

const envConfig =
  __KANBU_CONFIG__ as any as Config['app']['playground']['webConfig'] & {
    debug: boolean;
    version: string;
    adminAppUrl: string;
  };

export const AppSettings = {
  ...envConfig,
  debug:
    document.cookie.includes('debug=true') ||
    envConfig.debug ||
    import.meta.env.DEV,
  // PostHog configuration with fallback values
  postHog: {
    apiKey: envConfig.postHog?.apiKey || '', // Empty string will disable PostHog
    host: envConfig.postHog?.host || 'https://app.posthog.com',
  },
  // Chatbot configuration
  chatbotScriptUrl:
    envConfig.chatbotScriptUrl || 'https://loader.kanbu.ai/v0/chatbot.js',
};
